// eslint-disable-next-line no-restricted-imports
import {
  InvestmentPurposeAndNatureDto_Input,
  Query_LegalClientController_GetById_InvestmentPurposeAndNature_InvestmentDuration as InvestmentDurationApi,
  Query_LegalClientController_GetById_InvestmentPurposeAndNature_InvestmentObjectives_Items as InvestmentObjectiveApi,
  Query_LegalClientController_GetById_InvestmentPurposeAndNature_PlannedServices_Items as PlannedServiceApi,
} from 'api/generated/graphql';
import { LegalClientInvestmentPurposeAndNatureParam } from 'api/types/params';
import { lodash } from 'helpers';

export const parseLegalClientInvestmentPurposeAndNatureParam = (
  data: LegalClientInvestmentPurposeAndNatureParam
): InvestmentPurposeAndNatureDto_Input => ({
  otherInvestmentObjective: data.otherInvestmentObjective ?? null,
  otherPlannedServices: data.otherPlannedServices ?? null,
  investmentDuration: InvestmentDurationApi[data.investmentDuration],
  investmentObjectives: lodash
    .compact(data.investmentObjectives)
    .map((v) => InvestmentObjectiveApi[v]),
  plannedServices: lodash
    .compact(data.plannedServices)
    .map((v) => PlannedServiceApi[v]),
});
